// Context key consumed by TooltipContent: when set to `true`, descendant
// tooltips render inline instead of portalling to document.body. Used by the
// marketing splash showcase so tooltips inherit the parent 3D rotation
// rather than appearing in flat screen coordinates.
export const TOOLTIP_PORTAL_DISABLED_CONTEXT = Symbol("tooltip-portal-disabled");
